export default {
  name: "Appendix D - Special Recruitment for College and University Teachers",
  pageInfo: {
    text: "<b><u>Note:</u></b> Employers are required to complete Appendix D when option 1c under question H.b is selected on the Form ETA-9089.  Specifically, this Appendix collects information <u>only</u> if recruitment for the employer’s job opportunity is for a college or university teacher <u>and</u> the candidate was selected using the special recruitment process in accordance with 20 CFR 656.18.  If the employer is required to undergo supervised recruitment in accordance with 20 CFR 656.21, the Certifying Officer may complete this Appendix, on behalf of the employer, to document recruitment efforts.  <b><i>Submission of special recruitment and documentation procedures in any other form or format will not be accepted.</i></b>  All filers must review the Form ETA-9089 for completeness and accuracy prior to submission either by electronic filing or by mail.<br/><br/>If filing electronically, Appendix D will be available in the electronic filing system.  If filing by mail, the employer must download and submit the Form ETA-9089, Appendix A, and all other required appendices in order for the application to be considered complete. <b><i>In accordance with 20 CFR 656.17(a), the Department will not certify incomplete applications.</i></b>  Applications and documents submitted by mail should include a cover page with the name, title, address and phone number of the point of contact.  The cover page should also index the documents included in the mailing.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          code: "Appendix D.1",
          machine_name: "appDForeignWorkerDate",
          label:
            "Specify the date the foreign worker was selected for the position.",
          widget: "date",
          required: true,
          validate: [
            {
              isRequired: "occupationType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "college_university_teacher",
              },
            },
            "noFutureDate",
          ],
          tooltip:
            "Enter the date the foreign worker was selected for the position.  Use a month/day/full year (MM/DD/YYYY) format.",
        },
      ],
    },
    {
      fields: [
        {
          widget: "generic_table",
          width: "580px",
          headers: [
            {
              label:
                "Name(s) of national professional journal, educational organization publication, or other publication",
            },
            {
              label: "Start date of advertisement",
            },
          ],
          hideEmptyHeader: true,
          rows: [
            [
              {
                code: " Appendix D.2",
                label: `2.*`,
                machine_name: "appDPublication1",
                widget: "text",
                hideAsterisk: true,
                maxLength: 120,
                validate: [
                  {
                    isRequired: "occupationType",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "college_university_teacher",
                    },
                  },
                  "noNAs",
                ],
                tooltip: `Enter the name of the national professional journal, educational organization publication, or other publication in which the employer placed an advertisement for the job opportunity.  If not applicable, enter “N/A.”`,
              },
              {
                code: " Appendix D.2a",
                label: `2a.*`,
                widget: "date",
                machine_name: "appDPublicationDate1",
                // hideIcons: true,
                noFixedWidth: true,
                hideAsterisk: true,
                validate: [
                  {
                    requiredIfNotNA: "appDPublication1",
                    needsFieldValues: true,
                    message: "This field is required",
                  },
                  {
                    isRequired: "occupationType",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "college_university_teacher",
                    },
                  },
                  "noFutureDate",
                ],
                tooltip: `Enter the date on which the advertisement referenced in question 2 was started.  Use a MM/DD/YYYY format.  If not applicable, leave blank.`,
              },
            ],
            [
              {
                code: " Appendix D.3",
                label: "3.§",
                machine_name: "appDPublication2",
                widget: "text",
                hideAsterisk: true,
                maxLength: 120,
                validate: [
                  {
                    isRequired: "occupationType",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "college_university_teacher",
                    },
                  },
                ],
                tooltip: `Enter the name of the national professional journal, educational organization publication, or other publication in which the employer placed an advertisement for the job opportunity.  If not applicable, enter “N/A.”`,
              },
              {
                code: "Appendix D.3a",
                label: "3a.§",
                widget: "date",
                machine_name: "appDPublicationDate2",
                // hideIcons: true,
                noFixedWidth: true,
                validate: [
                  {
                    requiredIfNotNA: "appDPublication2",
                    needsFieldValues: true,
                    message: "This field is required",
                  },
                  "noFutureDate",
                ],
                tooltip: `Enter the date on which the advertisement referenced in question 3 was started.  Use a MM/DD/YYYY format.  If not applicable, leave blank.`,
              },
            ],
            [
              {
                code: "Appendix D.4",
                label: "4.§",
                machine_name: "appDPublication3",
                widget: "text",
                hideAsterisk: true,
                maxLength: 120,
                validate: [
                  {
                    isRequired: "occupationType",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "college_university_teacher",
                    },
                  },
                ],
                tooltip: `Enter the name of the national professional journal, educational organization publication, or other publication in which the employer placed an advertisement for the job opportunity.  If not applicable, enter “N/A.”`,
              },
              {
                code: "Appendix D.4a",
                label: "4a.§",
                widget: "date",
                machine_name: "appDPublicationDate3",
                // hideIcons: true,
                noFixedWidth: true,
                validate: [
                  {
                    requiredIfNotNA: "appDPublication3",
                    needsFieldValues: true,
                    message: "This field is required",
                  },
                  "noFutureDate",
                ],
                tooltip: `Enter the date on which the advertisement referenced in question 4 was started.  Use a MM/DD/YYYY format.  If not applicable, leave blank.`,
              },
            ],
          ],
        },
      ],
    },
    {
      fields: [
        {
          code: "Appendix D.5",
          machine_name: "appDRecruitmentInfo",
          label:
            "Specify additional recruitment information (up to 3,500 characters).",
          widget: "text_area",
          validate: [
            {
              isRequired: "occupationType",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "college_university_teacher",
              },
            },
            {
              minLengthWithNA: 5,
              message: "Minimum of 5 characters required",
            },
          ],
          minLength: 5,
          inputLimit: 3500,
          width: 10,
          rows: 10,
          tooltip:
            "Describe all other recruitment conducted by the employer for the position, including sources used.  A completion description must be completed in the space provided. <b>No attachments will be accepted</b>. If not applicable, enter “N/A.”",
        },
      ],
    },
  ],
};
